import Axios from "axios";
import {
  SET_HRM_BLOOD_GROUP_TYPE_LIST,
  UNSET_HRM_BLOOD_GROUP_TYPE_LIST,
  SET_HRM_GENDER_LIST,
  UNSET_HRM_GENDER_LIST,
  SET_HRM_RELIGION_LIST,
  UNSET_HRM_RELIGION_LIST,
  SET_HRM_MARITAL_STATUS_LIST,
  UNSET_HRM_MARITAL_STATUS_LIST,
  SET_HRM_DEPARTMENT_LIST,
  UNSET_HRM_DEPARTMENT_LIST,
  SET_HRM_DESIGNATION_LIST,
  UNSET_HRM_DESIGNATION_LIST,
  SET_HRM_EMPLOYEE_TYPE_LIST,
  UNSET_HRM_EMPLOYEE_TYPE_LIST,
  SET_OFFICE_LIST,
  UNSET_OFFICE_LIST,
  SET_HRM_SECTION_LIST,
  UNSET_HRM_SECTION_LIST,
} from "@/store/mutation-types";
import {
  getHrmBloodGroupList,
  getHrmGenderList,
  getHrmReligionList,
  getHrmMaritalStatusList,
  getHrmDepartmentList,
  getHrmDesignationList,
  getHrmEmployeeTypeList,
  getOfficeList,
  getHrmSectionList,
} from "@/store/api";

const state = {
  bloodGroups: [],
  genders: [],
  religions: [],
  maritalStatuses: [],
  departments: [],
  designations: [],
  employeeTypes: [],
  offices: [],
  sections: [],
};

const getters = {
  getBloodGroups(state) {
    return state.bloodGroups;
  },
  getGenders(state) {
    return state.genders;
  },
  getReligions(state) {
    return state.religions;
  },
  getMaritalStatuses(state) {
    return state.maritalStatuses;
  },
  getDepartments(state) {
    return state.departments;
  },
  getDesignations(state) {
    return state.designations;
  },
  getEmployeeTypes(state) {
    return state.employeeTypes;
  },
  getOffices(state) {
    return state.offices;
  },
  getSections(state) {
    return state.sections;
  },
};

const mutations = {
  [SET_HRM_BLOOD_GROUP_TYPE_LIST](state, data) {
    state.bloodGroups = data;
  },
  [UNSET_HRM_BLOOD_GROUP_TYPE_LIST](state) {
    state.bloodGroups = [];
  },
  [SET_HRM_GENDER_LIST](state, data) {
    state.genders = data;
  },
  [UNSET_HRM_GENDER_LIST](state) {
    state.genders = [];
  },
  [SET_HRM_RELIGION_LIST](state, data) {
    state.religions = data;
  },
  [UNSET_HRM_RELIGION_LIST](state) {
    state.religions = [];
  },
  [SET_HRM_MARITAL_STATUS_LIST](state, data) {
    state.maritalStatuses = data;
  },
  [UNSET_HRM_MARITAL_STATUS_LIST](state) {
    state.maritalStatuses = [];
  },
  [SET_HRM_DEPARTMENT_LIST](state, data) {
    state.departments = data;
  },
  [UNSET_HRM_DEPARTMENT_LIST](state) {
    state.departments = [];
  },
  [SET_HRM_DESIGNATION_LIST](state, data) {
    state.designations = data;
  },
  [UNSET_HRM_DESIGNATION_LIST](state) {
    state.designations = [];
  },
  [SET_HRM_EMPLOYEE_TYPE_LIST](state, data) {
    state.employeeTypes = data;
  },
  [UNSET_HRM_EMPLOYEE_TYPE_LIST](state) {
    state.employeeTypes = [];
  },
  [SET_OFFICE_LIST](state, data) {
    state.offices = data;
  },
  [UNSET_OFFICE_LIST](state) {
    state.offices = [];
  },
  [SET_HRM_SECTION_LIST](state, data) {
    state.sections = data;
  },
  [UNSET_HRM_SECTION_LIST](state) {
    state.sections = [];
  },
};

const actions = {
  getBloodGroups({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmBloodGroupList)
        .then((response) => {
          commit(SET_HRM_BLOOD_GROUP_TYPE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_BLOOD_GROUP_TYPE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getGenderTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmGenderList)
        .then((response) => {
          commit(SET_HRM_GENDER_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_GENDER_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getReligionTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmReligionList)
        .then((response) => {
          commit(SET_HRM_RELIGION_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_RELIGION_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getMaritalStatusTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmMaritalStatusList)
        .then((response) => {
          commit(SET_HRM_MARITAL_STATUS_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_MARITAL_STATUS_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getDepartments({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmDepartmentList)
        .then((response) => {
          commit(SET_HRM_DEPARTMENT_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_DEPARTMENT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getDesignations({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmDesignationList)
        .then((response) => {
          commit(SET_HRM_DESIGNATION_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_DESIGNATION_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getEmployeeTypes({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmEmployeeTypeList)
        .then((response) => {
          commit(SET_HRM_EMPLOYEE_TYPE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_EMPLOYEE_TYPE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getOffices({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getOfficeList)
        .then((response) => {
          commit(SET_OFFICE_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_OFFICE_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  getSections({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmSectionList)
        .then((response) => {
          commit(SET_HRM_SECTION_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_HRM_SECTION_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

